// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"campaign-status-label-component_uk-open__ywnG1","grecaptcha-badge":"campaign-status-label-component_grecaptcha-badge__MrpwS","status":"campaign-status-label-component_status__40xEQ","green":"campaign-status-label-component_green__eoTTF","orange":"campaign-status-label-component_orange__wmjXo"};
    if(module.hot) {
      // 1793877042207
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  